import { createContext } from "react";

export const BatchObjectiveModalContext = createContext();
